import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { MoneyFormat } from "../../libs";

function TrackPage({ props }) {
  const { onModal, data, lastTrack } = props;
  return (
    <div className="lacak">
      <div className="container mx-auto py-6 lg:py-10">
        {/* Ini Adalah Breadcrumb */}
        <div name="breadecrumb" className="flex items-center mb-6 lg:mb-8">
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
            Home
          </p>
          <img
            className="mr-3 lg:mr-5"
            src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
            alt="icon-arrow"
          />
          <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-blue">
            Lacak Pemeriksaan
          </p>
        </div>

        {/* Mulai Content  */}
        <div className="w-full flex justify-center">
          <div className="lacak-wrapper w-full lg:w-3/5 ">
            <div className="p-2 lg:px-12 lg:pt-10">
              <p className="header-title-bold text-xl lg:text-3xl colors-blue font-bold mb-3 lg:mb-6">
                Pemeriksaan Anda
              </p>

              {/* Item Section */}

              {data
                ? data.item_detail.length > 0 &&
                  data.item_detail.map((it, index) => (
                    <div key={index} className="flex">
                      <div className="w-20 h-20 lg:w-28 lg:h-28  mr-4 lg:mr-6">
                        <img
                          className="w-20 h-20 lg:w-28 lg:h-28 object-cover rounded-2xl "
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/assets/image/img_empty.png"; // some replacement image
                          }}
                          src={
                            process.env.REACT_APP_BACKEND_URL +
                            "/storage/" +
                            it.item_image
                          }
                          alt="img-media"
                        />
                      </div>
                      <div className="mb-10 w-2/3 lg:mb-10 ">
                        <p className="header-content colors-gray text-xs lg:text-sm">
                          Layanan Kesehatan
                        </p>
                        <p className="header-title-semi colors-blue mt-2 text-md w-2/3 lg:w-full lg:text-lg font-semibold ">
                          {it?.item_name ??
                            "PCR Swab Test (Drive Thru) Hasil 1 Hari Kerja"}
                        </p>
                        <p className="header-content colors-orange text-base mb-5 lg:text-lg mt-2 font-semibold ">
                          {"Rp. " + MoneyFormat(Number(it?.item_harga ?? 0))}
                        </p>
                        <div className="lg:flex items-center">
                          <div className="mr-0 lg:mr-20">
                            <p className="header-content colors-gray">
                              Tanggal Pemeriksaan
                            </p>
                            <div className="flex items-center mt-1 ">
                              <img
                                src={
                                  process.env.REACT_APP_BASE_URL +
                                  "/assets/icon/ic_date_detail.svg"
                                }
                                alt="icon-date"
                              />
                              <p className="header-content ml-2 colors-blue font-semibold">
                                {moment(it.item_booking_date).format(
                                  "DD MMMM YYYY"
                                )}
                              </p>
                            </div>
                          </div>
                          {/* {control && ( */}
                          <div className="mr-0 lg:mr-5 mt-3 lg:mt-0">
                            <p className="header-content colors-gray">
                              Waktu Pemeriksaan
                            </p>
                            <div className="flex items-center mt-1 ">
                              <img
                                src={
                                  process.env.REACT_APP_BASE_URL +
                                  "/assets/icon/ic_time.svg"
                                }
                                alt="icon-time"
                              />
                              <p className="header-content ml-2 colors-blue font-semibold">
                                {it?.item_booking_time ?? "00:00:00"} WIB
                              </p>
                            </div>
                          </div>
                          {/* )} */}
                        </div>
                      </div>
                      {/* {!control && (
                <div className="ready lg:ml-10 h-8 w-8 flex justify-center content-center">
                  <p className="colors-green text-sm lg:text-base mt-1">1x</p>
                </div>
              )} */}
                    </div>
                  ))
                : null}
            </div>

            {/* Gradient Section */}
            <div className="lacak-gradient mb-10">
              <div className="flex items-center content-center justify-between h-full pl-2  lg:px-10">
                <p className="header-title colors-blue text-sm lg:text-base font-semibold">
                  {lastTrack}...
                </p>
                {lastTrack !== "Belum terdapat tracking pemeriksaan" ? (
                  <div
                    onClick={onModal}
                    className="flex cursor-pointer items-center cursor-pointer"
                  >
                    <p className="header-title colors-blue text-sm lg:text-base font-semibold ">
                      Lihat Detail
                    </p>
                    <img
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_arrow_homepage.svg"
                      }
                      alt="icon-arrow"
                      className="ml-1 lg:ml-3 w-4 lg:w-auto lg:h-auto"
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>

            <div className="p-2 lg:px-12 lg:pb-10">
              {/* Information Section */}
              <div className="mb-10 lg:mb-10">
                <p className="header-title-semi colors-blue font-semibold text-lg lg:text-2xl mb-3 lg:mb-5">
                  Informasi Pribadi
                </p>
                <div className="flex mb-3 justify-between ">
                  <p className="header-content colors-gray text-sm lg:text-base">
                    Nama Pasien
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {data?.first_name ?? "Tidak ada nama"}
                  </p>
                </div>
                <div className="flex mb-3 justify-between ">
                  <p className="header-content colors-gray text-sm lg:text-base">
                    Tanggal Registrasi
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {moment(data?.tgl_registrasi ?? "2021-04-04").format(
                      "DD MMMM YYYY HH:mm:ss"
                    )}{" "}
                    WIB
                  </p>
                </div>
                <div className="flex mb-3 justify-between ">
                  <p className="header-content colors-gray text-sm lg:text-base">
                    Metode Pembayaran
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {data?.payment_method ?? "Tidak ada metode"}
                  </p>
                </div>
                <div className="flex mb-3 justify-between ">
                  <p className="header-content colors-gray text-sm lg:text-base">
                    Status Pembayaran
                  </p>
                  <p className="header-content colors-blue text-sm lg:text-base font-semibold">
                    {data?.payment_status_text ?? "Tidak ada status"}
                  </p>
                </div>
              </div>

              {/* Button Section */}

              {/* <Link to="/result/1">
                <button className="btn-white-border p-3 focus:outline-none w-full ">
                  <div className="text-white-border font-semibold lg:text-lg">
                    <div className="text-gray-400 lg:text-lg">
                      Hasil Pemeriksaan
                    </div>
                  </div>
                </button>
              </Link> */}

              <Link to="/">
                <div
                  name="button home"
                  className="w-full flex justify-center mt-5"
                >
                  <button className="btn-blue w-full p-3 focus:outline-none lg:w-full">
                    <div className="text-white font-semibold lg:text-lg">
                      Back to Home
                    </div>
                  </button>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrackPage;
